import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { changeLocale, langList } from "./index";

export function useLocale() {
  const { locale, t } = useI18n({ useScope: "global" });
  return { locale: computed(() => locale.value), t, changeLocale, langList };
}
